import React, {ChangeEvent, CSSProperties} from 'react';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';
import './inputFieldEditorComponent.scss'

export interface InputFieldEditorComponentProps {
  className?: string
  style?: CSSProperties
  value?: string
  type?: 'text' | 'number' | 'date' | 'password'
  name?: string
  ref?: any
  placeholder?: string
  disabled?: boolean
  required?: boolean
  children?: any
  valid?: boolean
  validText?: string
  invalid?: boolean
  invalidText?: string
  label?: string
  min?: number
  max?: number
  id?: string
  defaultValue?: string | number | string[] | undefined
  onChange?: (e: ChangeEvent<HTMLInputElement>)=>any
  onEnter?: (value?: string)=>any
}

interface IInputComponentSubComponents{
  Icon: React.FC<IIconInputProps>
}

const InputFieldEditorComponent: React.SFC<InputFieldEditorComponentProps> & IInputComponentSubComponents = (props) => {

  const handleKeyUp = (e: any) => {
    if(props.onEnter){
        if(e.key === 'Enter' || e.keyCode === 13){
            props.onEnter(e.target.value)
        }
    }
  }

  return (
    <div
      className={`input_field_editor_component-layout ${props.className ? props.className : ''}`}
      style={props.style}
    >
      {props.children}
      {props.label ?
        <LabelComponent>
          {props.label}
        </LabelComponent>
      :null}
      <input
          type={props.type ? props.type : 'text'}
          className={`form-control ${props.valid ? 'is-valid' : ''} ${props.invalid ? 'is-invalid' : ''} ${props.children ? 'icon-spacing' : ''}`}
          placeholder={props.placeholder}
          ref={props.ref}
          onChange={props.onChange}
          name={props.name}
          value={props.value}
          disabled={props.disabled}
          required={props.required}
          min={props.min}
          max={props.max}
          id={props.id}
          defaultValue={props.defaultValue}
          onKeyUp={(e) => handleKeyUp(e)}
      />
      {props.valid && props.validText ?
      <div className="valid-feedback">
          {props.validText}
      </div>
      : null}
      {props.invalid && props.invalidText ?
      <div className="invalid-feedback">
          {props.invalidText}
      </div>
      : null}
    </div>
  );
}

interface IIconInputProps{
  children?: any
  className?: string
  style?: CSSProperties
}

const Icon: React.FC<IIconInputProps> = (props) => {
  return(
      <div
        className={`container_icon-input ${props.className ? props.className : ''}`}
        style={props.style}
      >
          {props.children}
      </div>
  )
}

InputFieldEditorComponent.Icon = Icon

export default InputFieldEditorComponent;
